import { useContext } from "react";
import { Link } from "react-router";
import { GlobalStateContext } from "../controller/GlobalState";

export function ProductActions({ name }) {
  const { setIsOpen, setFormData } = useContext(GlobalStateContext);
  const discuss = () => {
    setFormData((previous) => ({ ...previous, subject: `${name} product enquiry` }));
    setIsOpen(true);
  };
  return <div className="ip-actions"><button className="ea-button ea-primary" onClick={discuss}>Discuss {name}</button><a className="ip-secondary" href="#capabilities">Explore capabilities</a></div>;
}

export function ProductFAQs({ items }) {
  return <section className="ip-section ip-faq" aria-labelledby="product-faq-heading"><h2 id="product-faq-heading">A few practical questions.</h2><div>{items.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}</div></section>;
}

export function ProductClosing({ name, children }) {
  return <section className="ip-section ip-closing">
    <div className="ip-closing-copy"><h2>See how {name} fits your work.</h2><p>{children}</p></div>
    <div className="ip-closing-links"><ProductActions name={name} /><Link to="/">Explore InQmise’s other products</Link></div>
  </section>;
}
